module.exports = __webpack_public_path__ + "img/member11.50f5c797.png";